import { useApolloClient } from "@apollo/client/react";
import { useCallback, useState } from "react";

import { CHAT_CONVERSATION_TRANSCRIPT } from "./gql";

const useChatConversationTranscript = () => {
  const client = useApolloClient();
  const [loading, setLoading] = useState(false);

  const loadTranscript = useCallback(
    async (id: string) => {
      setLoading(true);

      try {
        const { data } = await client.query({
          query: CHAT_CONVERSATION_TRANSCRIPT,
          variables: { id },
          fetchPolicy: "no-cache",
          context: { suppressFlashError: true },
        });
        return data?.intentChatConversation?.transcript;
      } finally {
        setLoading(false);
      }
    },
    [client]
  );

  return {
    loadTranscript,
    loading,
  };
};

export default useChatConversationTranscript;
